import { Card } from '@zorro/design-system/v2/Card';
import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { Grid, Stack } from '@zorro/web/design-system';

export const MajorMedicalPlanCardSkeleton = () => {
  return (
    <Card
      variant="white-border"
      style={{ borderColor: 'var(--mantine-color-zorroGray-2)' }}
    >
      <Grid align="start" justify="space-around" gap="lg">
        <Grid.Col span={4}>
          <Skeleton circle mb="xl" h={50} w={120} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Stack>
            <Skeleton h={16} />
            <Skeleton h={16} />
          </Stack>
        </Grid.Col>
        <Grid.Col span={4}>
          <Skeleton h={16} />
        </Grid.Col>
      </Grid>
    </Card>
  );
};
